export const CASH_BY_MEGA_PRODUCTS = [
  'factoraje',
  'creditopersonamoral',
  'arrendamiento',
  'cashcustom',
];

export const CRED_HIP_PRODUCT_ID = '64b4929c8dc45e53e4ec23db';
